import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const basketSaveForLaterSelector = createSelector(testTargetOffersSelector, offers => offers.basketSaveForLater || Empty.Object);

export { basketSaveForLaterSelector };
